/*$(document).ready(function() {
  // Überprüfen, ob die Auflösung maximal 770px beträgt
    if ($(window).width() <= 770) {
       
        // Ersetze die ID durch "snize-search-results-list-mode"
          $('#snize-search-results-grid-mode').attr('id', 'snize-search-results-list-mode');
          
          // Ändere das Inline-Style von allen Elementen mit der Klasse "snize-product" auf "width: 100%"
          $('.snize-product').css('width', '100% !important');
    }
});*/

$(document).ready(function () {
  if (window.location.pathname === '/products/kino-vino' || window.location.pathname === '/collections/aktionen-pakete-veranstaltungen/products/kino-vino' || window.location.pathname === '/products/oeffentliche-weinprobe-hohentwiel' || window.location.pathname === '/collections/aktionen-pakete-veranstaltungen/products/oeffentliche-weinprobe-hohentwiel') {
    $('p').filter(function () {
      return $(this).text().includes('zzgl. Versandkosten');
    }).each(function () {
      // Entferne nur den "zzgl. Versandkosten"-Teil
      $(this).html(function (i, html) {
        return html.replace(/, zzgl\.\s*<a [^>]+>Versandkosten<\/a>/, '');
      });
    });
  }
});
